import { useMessageContext } from "stream-chat-react";

import { formatDate } from "@/utils/datetime";

export function CustomMessageTimestamp() {
  const { message } = useMessageContext();

  if (!message.created_at) return null;

  const formattedTime = formatDate(
    message.created_at,
    "MMM d, yyyy 'at' h:mm a",
  );

  return <span className="str-chat__timestamp">{formattedTime}</span>;
}
